jQuery(document).ready(function() {
    if(jQuery('.video-image__slider').length > 0){
		jQuery('.video-image__slider').slick({
			infinite: true,
			dots: true,
			speed: 400,
			arrows: true,
			slidesToShow:1,
			nextArrow: '<button class="fa fa-arrow-right right-arrow"><span class="sr-only">right arrow</span></button>',
			prevArrow: '<button class="fa fa-arrow-left left-arrow"><span class="sr-only">left arrow</span></button>',
			dotsClass: 'custom_paging',
			customPaging: function (slider, i) {
				return (i + 1) + ' / ' + slider.slideCount;
			}
		}).on('afterChange', function(event, slick, currentSlide, nextSlide){
			jQuery('.video-image__slider .slick-track .slick-slide').each(function(){
				if(jQuery(this).find('.mejs__playpause-button').hasClass('mejs__pause')){
					jQuery('.mejs__playpause-button.mejs__pause button').click();
				}
			});
		});
		jQuery('.video-image__slider').each(function(){
			if(jQuery(this).find('.slick-slide').length == 1){
				jQuery(this).find('.custom_paging').hide();
			};
		});


		// jQuery('.video-image__slider .slick-arrow,.video-image__slider .custom_paging li').on('click', function(){
		// 	jQuery('.video-image__slider .slick-track .slick-slide').each(function(){
		// 		if(jQuery(this).find('.mejs__playpause-button').hasClass('mejs__pause')){
		// 			jQuery('.mejs__playpause-button.mejs__pause button').click();
		// 		}
		// 	});
		// });

	}
	
}); //Document Ready End
